/**
 * Simple page to show user they are not authorized to view a page. They get redirected here when the don't have the proper permissions or groups to view a page.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const Unauthorized = () => {
    return (
        <div className="martrak-page-content-margin text-xl">
            <i className="fa-solid fa-circle-exclamation mr-2 text-red-500" ></i>
            You are not authorized to view this page.
        </div>
    )
}